import Service from "../AuthService";

const Order = {
  getAllOrder() {
    return Service.get(`order`);
  },
  getOrder(request) {
    return Service.get(`order?id=${request.id}`);
  },
  saveOrder(payload) {
    return Service.post(`order`, payload);
  },
  getTestOrder() {
    return Service.get(`test-order`);
  },
  getOrderHistory(ln, status) {
    return Service.get(`order-history/${ln}/${status}`);
  },
  reportOrder(ln, token) {
    return Service.get(`report-order/${ln}?token=${token}`);
  },
  approveOrder(ln, token) {
    return Service.get(`approve-order/${ln}?token=${token}`);
  },
  rejectOrder(ln, token, payload) {
    return Service.put(`reject-order/${ln}?token=${token}`, payload);
  },
  updateLabType(id, payload) {
    return Service.put(`order/lab-type/${id}`, payload);
  },
  filterOrder(request) {
    let url = `order?page=${request.page_no}`;
    if (request.direction_id) {
      url += `&direction_id=${request.direction_id}`;
    }
    if (request.hospital_id) {
      url += `&hospital_id=${request.hospital_id}`;
    }
    if (request.hn) {
      url += `&hn${request.hn}`;
    }
    if (request.pet_name) {
      url += `&pet_name=${request.pet_name}`;
    }
    if (request.owner_name) {
      url += `&owner_name=${request.owner_name}`;
    }
    if (request.start_date) {
      url += `&start_date=${request.start_date}`;
    }
    if (request.end_date) {
      url += `&end_date=${request.end_date}`;
    }
    if (request.status_id) {
      url += `&status_id=${
        typeof request.status_id === "array"
          ? request.status_id.join(",")
          : request.status_id
      }`;
    }
    if (request.test_name) {
      url += `&test_name=${request.test_name}`;
    }
    if (request.receive) {
      url += `&receive=${request.receive}`;
    }
    if (request.daily_number) {
      url += `&daily_number=${request.daily_number}`;
    }
    if (request.ln) {
      url += `&ln=${request.ln}`;
    }
    if (request.status_id) {
      url += `&status_id=${request.status_id}`;
    }
    if (request.user) {
      url += `&user=${request.user}`;
    }
    if (request.ln) {
      url += `&ln=${request.ln}`;
    }
    if (request.includingApprove) {
      url += `&including_approve=${request.includingApprove}`;
    }
    if (request.hasDailyNumer) {
      url += `&has_daily_number=${request.hasDailyNumer}`;
    }
    if (request.is_out_lab !== null && request.is_out_lab !== undefined) {
      url += `&is_out_lab=${request.is_out_lab.join(",")}`;
    }
    if (request.test_type !== null && request.test_type !== undefined) {
      url += `&test_type=${request.test_type.join(",")}`;
    }
    if (request.is_shared !== null && request.is_shared !== undefined) {
      if (request.is_shared.length === 1) {
        url += `&is_shared=${request.is_shared[0] === "shared" ? true : false}`;
      }
    }
    if (request.is_printed !== null && request.is_printed !== undefined) {
      if (request.is_printed.length === 1) {
        url += `&is_printed=${
          request.is_printed[0] === "print" ? true : false
        }`;
      }
    }

    if (request.animal_id) {
      url += `&animal_id=${request.animal_id}`;
    }
    if (request.page_type !== null && request.page_type !== undefined) {
      url += `&page_type=${request.page_type}`;
    }
    return Service.get(`${url}`);
  },
  updateOrder(id, payload) {
    return Service.put(`order/${id}`, payload);
  },
  sharedReport(id, payload) {
    return Service.post(`order/shared/${id}`, payload);
  },
  countPrinted(id) {
    return Service.get(`order/printed-count/${id}`);
  },
  getApproverOrderByHospital(id) {
    return Service.get(`order/approve/by-hospital/${id}`);
  },
  deleteReport(id) {
    return Service.delete(`report/${id}`);
  },
  setMultiReceive(data) {
    return Service.post(`order/multiple-receive`, data);
  },
};

export default Order;
